import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationEmail } from 'src/app/shared/models/notificationEmail';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotificationEmailModalAjoutComponent } from '../modal/notificationEmail-modal-ajout/notificationEmail-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NotificationEmailModalDetailComponent } from '../modal/notificationEmail-modal-detail/notificationEmail-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-notificationEmail',
	templateUrl: './list-notificationEmail.component.html',
	styleUrls: ['./list-notificationEmail.component.scss']
})
export class ListNotificationEmailComponent implements OnInit {
	notificationEmail: NotificationEmail[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	notificationEmailCsvFile: File = null;
	searchedSkill = '';
	searchedTitle = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstTitle';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editNotificationEmailModalRef: BsModalRef;
	addNotificationEmailModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getNotificationEmail();
		this.isAddable = true;
	}

	getNotificationEmail(): void {
		this.isListingLoading = true;
		this.facade.notificationEmailService.getAllNotificationEmail().subscribe({
			next: (val) => {
				this.notificationEmail = val.filter((e) => e.title !== 'Sans');
				this.itemsPerPage = this.notificationEmail.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.notificationEmail = [];
			}
		});
	}

	selectNotificationEmail(notificationEmail: NotificationEmail): void {
		const link = ['/notificationEmail', notificationEmail.id];
		this.router.navigate(link);
	}

	importNotificationEmail(event: any): void {
		this.notificationEmailCsvFile = event.target.files[0];

		this.facade.notificationEmailService
			.importNotificationEmail(this.notificationEmailCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} notificationEmail ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getNotificationEmail();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.addNotificationEmailModalRef = this.modalService.show(
			NotificationEmailModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addNotificationEmailModalRef.onHide.subscribe((reason: string | any) => {
			this.getNotificationEmail();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(notificationEmail: NotificationEmail) {
		const initialState = {
			notificationEmail: notificationEmail
		};
		this.editNotificationEmailModalRef = this.modalService.show(
			NotificationEmailModalDetailComponent,
			{
				class: 'modal-lg',
				initialState
			}
		);

		this.editNotificationEmailModalRef.onHide.subscribe((reason: string | any) => {
			this.getNotificationEmail();
		});
	}
}
